export const C = {
  // Brand colors (locked — EXIQ brand, not customizable per org)
  primary: "#22D3EE",
  onyx: "#0A1720",
  red: "#DC2626",
  stone: "#535C62",
  fog: "#B5B9BC",
  white: "#FFFFFF",
  onyxLight: "#0F2230",
  onyxMid: "#142D3E",
  onyxDeep: "#061018",
  textMuted: "#7A8894",
};

// ─── EXIQ Theme — Dark & Light ───
// Single brand theme. Dark is default. User can toggle light mode.
export const THEMES = {
  dark: {
    bg: "#0A1720",
    surface: "#0F2230",
    surfaceAlt: "#142D3E",
    border: "#142D3E",
    headerBg: "#061018",
    text: "#FFFFFF",
    textBold: "#FFFFFF",
    textSec: "#B5B9BC",
    textMuted: "#7A8894",
    inputBg: "#142D3E",
    hoverBg: "#142D3E66",
    badgeBg: (c) => `${c}22`,
    insightBg: (c) => `${c}0C`,
  },
  light: {
    bg: "#F0F2F4",
    surface: "#FFFFFF",
    surfaceAlt: "#F5F6F8",
    border: "#D8DCE0",
    headerBg: "#1A2332",
    text: "#1A2332",
    textBold: "#0A1720",
    textSec: "#4A5568",
    textMuted: "#6B7280",
    inputBg: "#EDF0F2",
    hoverBg: "#E8EAEE66",
    badgeBg: (c) => `${c}18`,
    insightBg: (c) => `${c}0A`,
  },
};

export const PIE_COLORS = [
  "#22D3EE",
  "#38BDF8",
  "#2DD4BF",
  "#60A5FA",
  "#818CF8",
  "#67E8F9",
  "#A78BFA",
  "#34D399",
  "#22D3EE99",
  "#38BDF899",
];

export const FONTS = { primary: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif" };

export const S = {
  app: { fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif", minHeight: "100vh" },
  header: (w) => ({ padding: w < 640 ? "0 12px" : "0 32px", position: "sticky", top: 0, zIndex: 200 }),
  main: (w) => ({ maxWidth: 1480, margin: "0 auto", padding: w < 640 ? "16px 10px 32px" : w < 1024 ? "20px 16px 40px" : "24px 32px 48px" }),
  card: (w) => ({ borderRadius: 10, padding: w < 640 ? 14 : 24, marginBottom: w < 640 ? 14 : 20 }),
  cardTitle: { fontSize: 11, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 16 },
  kpiLabel: { fontSize: 10, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 6 },
  kpiSub: { fontSize: 11, marginTop: 5 },
  grid2: (w) => ({ display: "grid", gridTemplateColumns: w < 768 ? "1fr" : "1fr 1fr", gap: w < 640 ? 14 : 20 }),
  grid3: (w) => ({ display: "grid", gridTemplateColumns: w < 640 ? "1fr" : w < 1024 ? "1fr 1fr" : "1fr 1fr 1fr", gap: w < 640 ? 14 : 20 }),
  select: (w) => ({ border: `1px solid #142D3E`, borderRadius: 6, padding: w < 640 ? "7px 10px" : "8px 14px", fontSize: w < 640 ? 12 : 13, fontFamily: "'Inter',sans-serif", outline: "none", cursor: "pointer", width: "100%", boxSizing: "border-box" }),
  btn: { background: C.primary, color: "#0A1720", border: "none", borderRadius: 6, padding: "9px 20px", fontSize: 13, fontWeight: 700, fontFamily: "'Inter',sans-serif", cursor: "pointer" },
  btnOutline: { background: "transparent", color: C.primary, border: `1px solid ${C.primary}55`, borderRadius: 6, padding: "8px 16px", fontSize: 13, fontWeight: 700, fontFamily: "'Inter',sans-serif", cursor: "pointer" },
  tab: (active, w) => ({ padding: w < 640 ? "8px 12px" : "10px 20px", borderRadius: 6, fontSize: w < 640 ? 12 : 13, fontWeight: 700, cursor: "pointer", border: "none", fontFamily: "'Inter',sans-serif", background: active ? C.primary : "transparent", color: active ? "#0A1720" : "#9BA8B0" }),
  dropZone: (dragging, w) => ({ border: `2px dashed ${dragging ? C.primary : "#142D3E"}`, borderRadius: 8, padding: w < 640 ? "32px 16px" : "48px 32px", textAlign: "center", cursor: "pointer" }),
  table: { width: "100%", borderCollapse: "separate", borderSpacing: "0 2px", fontSize: 13 },
  tableWrap: { overflowX: "auto", WebkitOverflowScrolling: "touch" },
  th: { textAlign: "left", padding: "10px 12px", fontWeight: 700, fontSize: 10, textTransform: "uppercase", letterSpacing: "0.06em", whiteSpace: "nowrap" },
  td: { padding: "10px 12px" },
  badge: (color) => ({ display: "inline-block", padding: "3px 10px", borderRadius: 4, fontSize: 11, fontWeight: 700, background: `${color}22`, color }),
  heatCell: (intensity) => ({ padding: "8px 12px", borderRadius: 4, textAlign: "center", fontWeight: 700, fontSize: 14, background: `#22D3EE${Math.round((0.06 + intensity * 0.6) * 255).toString(16).padStart(2, "0")}`, color: intensity > 0.4 ? "#0A1720" : "#22D3EE", border: "1px solid #142D3E" }),
};
